<template>
  <div>
    <div class="head">账户设置</div>
    <el-form ref="form" :model="form" label-width="85px" >
      <i class="neccesary_key"></i>
      <el-form-item label="昵称" :required="true">
        <el-input @change="inputName()" v-model="form.loginName" minlength="2" maxlength="8"></el-input>
      </el-form-item>

      <el-form-item label="原密码" v-if="!isEmailUpdPwd">
        <el-input @change="inputName()" v-model="form.dqPws" minlength="2" maxlength="8" type="password"  show-password></el-input>
        <span style="color:#409EFF;cursor: pointer;" @click="isEmailUpdPwd=true">通过邮箱验证码修改</span>
      </el-form-item>
      
      <el-form-item label="邮箱验证码" class="yxyzm" v-else >
        <el-input @change="inputName()" v-model="form.emailYzm" minlength="2" maxlength="8"></el-input>
        <div class="yzmShow" :class="numberYzmTime>0&&'yzmShowNum'" @click="getYzmNum">{{numberYzmTime>0?`${numberYzmTime}秒`:'获取验证码'}}</div>
        <span style="color:#409EFF;cursor: pointer; margin-left:10px;" @click="isEmailUpdPwd=false">通过原密码修改</span>
      </el-form-item>

      <el-form-item label="新密码">
        <el-input @change="inputName()" v-model="form.pwa" minlength="2" maxlength="8" type="password"  show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input @change="inputName()" v-model="form.qrPwd" minlength="2" maxlength="8" type="password" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { changPwd,sendEmail } from "@/services";
export default {
  data() {
    return {
      isEmailUpdPwd:false,    //是否由获取验证码的方式修改密码
      token:'',
      userInfo:null,
      form: {
        loginName:'',   //昵称
        dqPws:'',   //当前密码
        emailYzm:'',   //验证验证码
        pwa:'',   //密码
        qrPwd:'',   //确认密码
      },
      ylForm:null,   //
      numberYzmTime:0,  //剩余时间







      centersED: "", //中间转换
      field: [],
      sorts: [], // 擅长领域分类
      tempField: [],
      options: [
        // 省区
        {
          value: "省区",
          label: "省区",
          children: [
            {
              value: "河北省",
              label: "河北省",
            },
            {
              value: "山西省",
              label: "山西省",
            },
            {
              value: "辽宁省",
              label: "辽宁省",
            },
            {
              value: "吉林省",
              label: "吉林省",
            },
            {
              value: "黑龙江省",
              label: "黑龙江省",
            },
            {
              value: "江苏省",
              label: "江苏省",
            },
            {
              value: "浙江省",
              label: "浙江省",
            },
            {
              value: "安徽省",
              label: "安徽省",
            },
            {
              value: "福建省",
              label: "福建省",
            },
            {
              value: "江西省",
              label: "江西省",
            },
            {
              value: "山东省",
              label: "山东省",
            },
            {
              value: "河南省",
              label: "河南省",
            },
            {
              value: "湖北省",
              label: "湖北省",
            },
            {
              value: "湖南省",
              label: "湖南省",
            },
            {
              value: "广东省",
              label: "广东省",
            },
            {
              value: "海南省",
              label: "海南省",
            },
            {
              value: "四川省",
              label: "省",
            },
            {
              value: "贵州省",
              label: "贵州省",
            },
            {
              value: "云南省",
              label: "云南省",
            },
            {
              value: "陕西省",
              label: "陕西省",
            },
            {
              value: "甘肃省",
              label: "甘肃省",
            },
            {
              value: "青海省",
              label: "青海省",
            },
            {
              value: "台湾省",
              label: "台湾省",
            },
          ],
        },
        {
          value: "自治区",
          label: "自治区",
          children: [
            {
              value: "内蒙古自治区",
              label: "内蒙古自治区",
            },
            {
              value: "广西壮族自治区",
              label: "广西壮族自治区",
            },
            {
              value: "新疆维吾尔族自治区",
              label: "新疆维吾尔族自治区",
            },
            {
              value: "西藏自治区",
              label: "西藏自治区",
            },
            {
              value: "宁夏回族自治区",
              label: "宁夏回族自治区",
            },
          ],
        },
        {
          value: "直辖市",
          label: "直辖市",
          children: [
            {
              value: "北京市",
              label: "北京市",
            },
            {
              value: "天津市",
              label: "天津市",
            },
            {
              value: "上海市",
              label: "上海市",
            },
            {
              value: "重庆市",
              label: "重庆市",
            },
          ],
        },
        {
          value: "特别行政区",
          label: "特别行政区",
          children: [
            {
              value: "香港特别行政区",
              label: "香港特别行政区",
            },
            {
              value: "澳门特别行政区",
              label: "澳门特别行政区",
            },
          ],
        },
      ],
      isChanged: true, // 基本资料如没有修改则不能点击保存
      initInfo: {}, // 初始化用户信息备份
    };
  },
  created() {
    this.token = localStorage.getItem('token');
    try {
      let ui = sessionStorage.getItem('userInfo');
      if(ui){
        this.userInfo = JSON.parse(ui);
        this.form.loginName = this.userInfo.name;
        this.ylForm = JSON.parse(JSON.stringify(this.form));
      }
    } catch (error) {
      
    }
  },
  methods: {
    //获取验证码
    getYzmNum(){
      if(this.numberYzmTime>0)return;
      this.getYzm()
      this.numberYzmTime = 5;
      let t = setInterval(() => {
        this.numberYzmTime--;
        if(this.numberYzmTime<=0){
          clearInterval(t);
        }
      }, 1000);
    },

    getYzm(){
      sendEmail({email:this.userInfo.email,name:this.userInfo.loginName||'',type:0}).then(res=>{
        if(res.success){
          this.$message.success("验证码发送成功!");
        }else{
          this.$message.warning(res.message);
        }
      }).catch(err=>{
        this.$message.warning("发送验证码失败!");
      })
    },

    onSubmit(){
      let {loginName,dqPws,emailYzm,pwa,qrPwd} = this.form;
      let data = { userName:loginName,email:this.userInfo.email,newPwd1:pwa,newPwd2:qrPwd};
      if(!loginName){
        this.$message.warning('请输入昵称');
        return 
      }
      if(!this.isEmailUpdPwd){
        if(!dqPws){
          this.$message.warning('请输入原密码');
          return 
        }
        data.oldPwd = dqPws;
      }else{
        if(!emailYzm){
          this.$message.warning('请输入邮箱验证码');
          return 
        }
        data.code = emailYzm;
      }
      if(!pwa){
        this.$message.warning('请输入新密码');
        return 
      }
      if(!qrPwd){
        this.$message.warning('请输入确认密码');
        return 
      }
      if(pwa!==qrPwd){
        this.$message.warning('新密码和确认密码不一致');
        return 
      }
      
      changPwd(data).then(res=>{
        console.log(res);
        if(res.success){
          this.$message.success('修改成功');
          this.$router.push('/login');
          localStorage.clear();
          sessionStorage.clear();

        }else{  
          this.$message.warning(res.message);
        }
      })

    },

    ///用户名
    async inputName() {
      this.form.name = this.centersED; //赋值
    },
    ///个性签名
    async inputintro() {
      this.form.intro = this.centersED; //赋值
    },
    async init() {
      let info = await QUERYED(
        "post",
        "",
        'PCUsers(where: {id: {_eq: "' +
        this.$store.state.userinfo.id +
        '"}}) {id    name    loginName    intro  email  img    phone    birthday  address   industry}'
      );
      this.form = info.data.PCUsers[0];
      if (info.data.PCUsers[0].address != null) {
        this.form.address = info.data.PCUsers[0].address;
      }
      if (info.data.PCUsers[0].phone === null) {
        this.form.phone = "";
      }
      if (info.data.PCUsers[0].email === null) {
        this.form.email = "";
      }
      if (info.data.PCUsers[0].birthday === "") {
        this.form.birthday = "";
      }
      if (info.data.PCUsers[0].industry !== "") {
        this.field.push(info.data.PCUsers[0].industry);
      }

      // 初始化领域
      let info2 = await QUERYED("post", "", "Type {id    type}");
      console.log("info2", info2);
      if (info2.data.Type.length != 0) {
        this.sorts = [];
        for (let i = 0; i < info2.data.Type.length; i++) {
          this.sorts.push(info2.data.Type[i].type);
        }
      }
    },
    cancelChange() {
      this.init(); // 取消更改
    },
    handleChange(value) {
      console.log(value);
    },
  },
};
</script>
<style scoped>
.head {
  border-bottom: 1px solid #b5b5b5;
  line-height: 50px;
  margin-bottom: 40px;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 800;
}

.label {
  margin-left: -50px;
}

.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 50%;
  margin-right: 10px;
}

/* 加入红星 */
.neccesary_key {
  content: "*";
  color: #ff2d52;
  font-size: 14px;
}

/* .neccesary_key .el-form-item__label:before{
  content: "*";
  color: #ff2d52;
  font-size: 14px;
} */

/* 最多3个 */
.check-tip {
  color: #dcdfe6;
  font-size: 10px;
}

/* 复选框改变样式 */
.changeinput>>>.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 7px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 1;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.changeinput>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

.yxyzm >>>.el-form-item__content{
  display:flex;
}
.yxyzm >>>.el-input{
  width:35%;
  margin-right:1%;
}
.yzmShow{
  width:14%;
  height:100%;
  border:1px solid #409eff;
  color:#409eff;
  border-radius:5px;
  text-align:center;
  cursor: pointer;
}

.yzmShowNum{
  border-width:0;
  color:#fff;
  background-color:#ddd;
  cursor: no-drop;
}
</style>
